const defaultState = {
    correctionRequest: {},
    error: null,
    saving: false,
    saved: false
};

const postCorrectionRequest = (state = defaultState, action) => {
    switch (action.type) {
        case 'POST_CORRECTION_REQUEST_PENDING': {
            return {
                ...state, saving: true, error: null
            };
        }
        case 'POST_CORRECTION_REQUEST_FULFILLED': {
            return {
                ...state,
                saving: false,
                error: null,
                saved: true,
                correctionRequest: action.payload
            };
        }
        case 'POST_CORRECTION_REQUEST_REJECTED': {
            return {
                ...state,
                saving: false,
                saved: false,
                error: action.payload
            };
        }
        default: {
            break;
        }
    }

    return state;
};

export default postCorrectionRequest;


// WEBPACK FOOTER //
// ./src/reducers/postCorrectionRequest.js